export const pleaseSelectItem = { uniqueCode: -1, name: "選択して下さい" };
export const BUTTON_LOGKUN = "BUTTON_LOGKUN";
export const BUTTON_LOGKUN_SP = "BUTTON_LOGKUN_SP";
export const ICON_LOGKUN = "ICON_LOGKUN";
